import { render, staticRenderFns } from "./AseguradoConSvg.vue?vue&type=template&id=7270b061&"
import script from "./AseguradoConSvg.vue?vue&type=script&lang=js&"
export * from "./AseguradoConSvg.vue?vue&type=script&lang=js&"
import style0 from "./AseguradoConSvg.vue?vue&type=style&index=0&id=7270b061&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports